<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>

  <prox-activation-checklist *ngIf="isValidateActivated" [activationErrors]="activationService.activateErrors"
    [entityName]="account!.name" [activationService]="activationService"></prox-activation-checklist>
  <div class="qb-list-actions">
    <p-button id="addApprovalTreeBtn" (click)="onAtAdd()" size="small" label="Add Proximity Account Organization Tree"
      icon="pi pi-plus" [disabled]="isReadOnly()"></p-button>
    <span class="qb-status-message">{{statusMessage()}}</span>
  </div>
  <p-splitter class="w-full grow qb-splitter-after-actions" layout="vertical" styleClass="h-full"
    [panelSizes]="[dims[0], dims[1]]">
    <ng-template pTemplate>
      <div class="qb-splitter-panel">
        <div class="qb-splitter-grid w-full">
          <prox-ag-grid gridId="approvalTreesGrid" [gridOptions]="atGridOptions"
            [rowData]="approvalTrees"></prox-ag-grid>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <p-splitter *ngIf="treeData" class="w-full h-full" layout="vertical" styleClass="h-full"
        [panelSizes]="[dims[2], dims[3]]">
        <ng-template pTemplate>
          <div class="qb-splitter-panel">
            <div class="qb-child-actions">
              <p-button id="addAdminGroupsBtn" [disabled]="!selectedApprovalTree || isReadOnly()"
                (onClick)="onTreeAttachToAdminGroup()" size="small" label={{addAdminGroupsLabel()}}
                icon="pi pi-plus"></p-button>
              <p-button *ngIf="selectedTreeItem" [disabled]="!selectedApprovalTree" (onClick)="onShowUsers()"
                size="small" label={{showUsersLabel()}} icon="pi pi-plus" styleClass="ml-2"></p-button>
              <span class="ml-3 inline-flex items-center gap-1">
                <p-checkbox [(ngModel)]="showInactivePugs" [binary]="true" inputId="showInactivePugs"
                  (onChange)="onShowInactivePugsChanged()" />
                <label for="showInactivePugs" class="text-sm">Show Inactive Program User Groups</label>
              </span>
            </div>
            <div class="qb-splitter-grid">
              <prox-ag-grid gridId="approvalTreesDataGrid" [gridOptions]="treeGridOptions" [rowData]="treeData">
              </prox-ag-grid>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate>
          <div *ngIf="usersOrAdmins && showUsers" class="qb-splitter-panel">
            <div class="qb-splitter-grid">
              <prox-ag-grid [gridOptions]="userGridOptions" [rowData]="usersOrAdmins">
              </prox-ag-grid>
            </div>
          </div>
        </ng-template>
      </p-splitter>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>